import { useTranslation } from 'react-i18next'
import { Spinner } from 'components/UnvUI'

import styles from './CheckRow.module.scss'

const fmtDate = (iso) => {
  if (!iso) return '—'
  try {
    return new Date(iso).toLocaleString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })
  } catch {
    return '—'
  }
}

const statusClass = {
  done: styles.success,
  completed: styles.success,
  pending: styles.warn,
  running: styles.warn,
  failed: styles.danger,
}

const CheckRow = ({ check, onRun, onView, running }) => {
  const { t } = useTranslation('common')
  const statusLabel = {
    done: t('plagiarism.status_done'),
    completed: t('plagiarism.status_done'),
    pending: t('plagiarism.queued'),
    running: t('plagiarism.running'),
    failed: t('plagiarism.status_failed'),
  }
  const similarity =
    check.percent_plagiarism != null
      ? Number(check.percent_plagiarism)
      : check.borrowings != null
      ? Number(check.borrowings)
      : null

  return (
    <div className={styles.row}>
      <div className={styles.main}>
        <div className={styles.title}>
          {check.file_name || check.document_name || t('plagiarism.check_label', { id: check.id })}
        </div>
        <div className={styles.meta}>
          <span>{check.target_kind_display || check.target_kind || '—'}</span>
          <span>{fmtDate(check.requested_at || check.created_at)}</span>
        </div>
      </div>

      <div className={styles.similarity}>
        {similarity != null ? (
          <>
            <div className={styles.simValue}>{similarity.toFixed(1)}%</div>
            <div className={styles.simLabel}>{t('plagiarism.matches_label')}</div>
          </>
        ) : (
          <div className={styles.simEmpty}>—</div>
        )}
      </div>

      <div className={styles.statusCell}>
        <span className={`${styles.badge} ${statusClass[check.status] || ''}`}>
          {statusLabel[check.status] || check.status_display || check.status || '—'}
        </span>
      </div>

      <div className={styles.actions}>
        <button
          className={styles.btnPrimary}
          onClick={() => onRun(check)}
          disabled={running || check.status === 'running'}
        >
          {running || check.status === 'running' ? (
            <Spinner size={16} />
          ) : (
            t('plagiarism.run_btn')
          )}
        </button>
        <button className={styles.btnGhost} onClick={() => onView(check)}>
          {t('plagiarism.details_btn')}
        </button>
      </div>
    </div>
  )
}

export default CheckRow
